import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { HubstaffTimeEntryDTO } from '../../core/models/hubstaff-entities.model';
import { LozengeComponent } from '../../shared/lozenge/lozenge.component';
import { BtnClickEvent, ButtonComponent } from '../../shared/button/button.component';
import { IconTypes } from '../../shared/icon/icon.component';
import { SpinnerComponent } from '../../shared/spinner/spinner.component';

export interface LinkTimeEntryEvent {
  btnEvent: BtnClickEvent;
  timeEntry: HubstaffTimeEntryDTO;
}

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  standalone: true,
  imports: [NgFor, DatePipe, NgIf, LozengeComponent, ButtonComponent, SpinnerComponent],
})
export class ActivitiesComponent {
  @Input() loading = false;
  @Input() timeEntries: HubstaffTimeEntryDTO[] = [];
  @Output() onUnlinkTimeEntry = new EventEmitter<LinkTimeEntryEvent>();
  @Output() onLinkTimeEntry = new EventEmitter<LinkTimeEntryEvent>();

  get IconTypes() {
    return IconTypes;
  }

  onActionClick(event: BtnClickEvent, entry: HubstaffTimeEntryDTO): void {
    if (entry.jiraWorklogId) {
      this.onUnlinkTimeEntry.emit({ btnEvent: event, timeEntry: entry });

      return;
    }

    this.onLinkTimeEntry.emit({ btnEvent: event, timeEntry: entry });
  }
}
